function mob_slide_logos_init(s_width){
	if(s_width<=768){
		if(!jQuery('.mob_slide_logos').hasClass('mob_slide_add')) {
			jQuery('.mob_slide_logos').addClass('mob_slide_add');

			var slickSlider = jQuery('.mob_slide_add');
			if(slickSlider.hasClass('slick-initialized')) {
				slickSlider.slick('destroy');
			}

			slickSlider.slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				dots: false,
				centerMode: true,
				arrows: false,
				variableWidth: true,
				focusOnSelect: true,
				infinite: true,
				autoplay: false,
				autoplaySpeed: 2000
			});
		}
	}else{
		var slickSlider = jQuery('.mob_slide_add');
		if(slickSlider.hasClass('slick-initialized')) {
			slickSlider.slick('destroy');
			jQuery('.mob_slide_logos').removeClass('mob_slide_add');
		}else{
			jQuery('.mob_slide_logos').removeClass('mob_slide_add');
		}
	}
}
if(jQuery('.mob_slide_logos').length > 0){
	jQuery( window ).resize(function() {
		var s_width = jQuery( window ).width();
		mob_slide_logos_init(s_width);
		console.log('resize width:'+s_width);
	});

	var s_width = jQuery( window ).width();
	mob_slide_logos_init(s_width);
	console.log('load width:'+s_width);
}

if(jQuery('.bidet_featured_right .product-grid').length > 0){
	var slickSlider = jQuery('.bidet_featured_right .product-grid');
	slickSlider.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		//centerMode: true,
		arrows: true,
		// variableWidth: true,
		focusOnSelect: true,
        initialSlide: -1,
		infinite: true,
		autoplay: false,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					arrows: true
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					arrows: false
				}
			},
			{
				breakpoint: 767,
				settings: {
					arrows: false,
					infinite: true,
					centerPadding: '100px',
					initialSlide: 1,
					centerMode: true,
					slidesToShow: 2
				}
			},
			{
				breakpoint: 450,
				settings: {
					centerPadding: '100px',
					arrows: false,
					infinite: true,
					centerMode: true,
					initialSlide: 0,
					slidesToShow: 1
				}
			}
		]
	});
}

onload = function() {
	var fcBody = document.querySelector(".collection_bidet_comparison .fix-column > .tbody"),
		rcBody = document.querySelector(".collection_bidet_comparison .rest-columns > .tbody"),
		rcHead = document.querySelector(".collection_bidet_comparison .rest-columns > .thead");
	rcBody.addEventListener("scroll", function() {
		fcBody.scrollTop = this.scrollTop;
		rcHead.scrollLeft = this.scrollLeft;
	}, { passive: true });
};
